import Flex from 'components/Flex'
import { StyledTabs } from 'components/TabsPaneStyles'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const StyledTab = styled(StyledTabs)`
  .ant-tabs-nav::before {
    border-bottom: none;
  }
  .ant-tabs-tab {
    border-bottom: none !important;
    padding: 15px 0 !important;
  }
  > .ant-tabs-nav {
    width: 100% !important;
  }
  .ant-tabs-nav {
    margin: 0 !important;
  }
  .ant-tabs-tab-btn {
    color: ${COLORS.GREY_T_50_2};
    text-shadow: 0 0 0.25px currentcolor;
  }
  .ant-tabs-ink-bar {
    background: ${COLORS.PRIMARY} !important;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${COLORS.PRIMARY};
  }

  width: 100%;

  .ant-tabs-content {
    height: 250px !important;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`
export const PaddedDiv = styled(Flex)`
  padding: 20px 25px;
  gap: 30px;
`
export const DrivesTab = styled.div`
  margin: 20px 0;
`

export const DriveDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  text-align: center;
  color: ${COLORS.GREY_T_60};
`

export const TopHeader = styled(Flex)`
  position: relative;
  width: 100%;
  font-size: 2em;
`
export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XL};
  line-height: 28px;
  color: ${COLORS.GREY_P_100};
`

export const TopRightFlex = styled(Flex)`
  gap: 15px;
  align-items: center;
  z-index: 1;
`
export const ToggleContainer = styled(Flex)`
  width: fit-content;
  height: 38px;
  justify-content: center;
  align-items: center;
  padding: 3px 4px;
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 10px;
  cursor: pointer;
`
export const ToggleDate = styled(Flex)``
export const SeetingDiv = styled.div`
  border: 1px solid ${COLORS.GREY_T_90};
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 10px;
  padding: 6px;
  gap: 9px;
  width: 38px;
  height: 38px;
  cursor: pointer;
`
export const CommonToggle = styled.div`
  padding: 0.3rem 0.7rem;
  color: ${props => props.color};
  background: ${props => props.background} !important;
  border-radius: 8px;
  transition: 0.5s;
`
export const DriveCount = styled.div`
  background-color: ${COLORS.RED_T_20};
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XS};
  line-height: 1rem;
  padding: 0.1rem 0.3rem;
  color: ${COLORS.WHITE};
  border-radius: 0.4rem;
  margin-left: 0.2rem;
`
export const CandidatesSpan = styled.span`
  padding: 2px 6px;
  margin-left: 10px;
  width: 29px;
  height: 19px;
  background: ${COLORS.PAGE_BORDER};
  border-radius: 20px;
`
export const ToggleText = styled.div`
  font-size: 0.8rem;
  color: ${props => props.color};
  font-weight: ${FONT.FW_600};
  padding: 0.5rem 0;
`
